import $ from 'jquery';

export default {
  /**
   * For controls that need to be adjusted along a slider. E.g. volume bars, video progress bars
   *
   * For instance
   *   * If you have a slider that is 500 pixels long and it represents the playback time
   *   * The playback time is 600 seconds
   *   * The click event was at the 250th pixel
   *   * The response will be 300 (50% of 600)
   *
   * @param {event} mouseEvent - An event from a click having a `.pageX` attribute
   * @param {number} totalValue - The top end of the range being adjusted for.
   *
   * @returns {number} - a number that is N% of the totalValue based
   * on where the mouse was clicked on the `mouseEvent.currentTarget`
   */
  getSliderValueX(mouseEvent, totalValue, isFullScreen, sliderElement) {
    const pageX   = mouseEvent.nativeEvent? mouseEvent.nativeEvent.pageX : mouseEvent.pageX;
    if(isFullScreen === true) {
      const offsetWidth = (mouseEvent.currentTarget === document) ? document.documentElement.offsetWidth: mouseEvent.currentTarget.offsetWidth,
      mousePosition = pageX,
      sliderPercent = mousePosition / offsetWidth;
      return totalValue * sliderPercent;
    } else {
      const percentScrubbed = (((pageX - $(sliderElement).offset().left) / sliderElement.offsetWidth)),
            seekTo = percentScrubbed * totalValue;
      return seekTo;
    }
  },
  getSliderValueY(mouseEvent, totalValue) {
    const pageY         = mouseEvent.nativeEvent? mouseEvent.nativeEvent.pageY : mouseEvent.pageY,
          mousePosition = pageY - this.findPos(mouseEvent.currentTarget)[1],
          sliderPercent = (mousePosition / mouseEvent.currentTarget.offsetHeight);
    return  (totalValue - (totalValue * sliderPercent));
  },
  findPos(obj) {
    if(obj === document) {
      return [0, 0];
    }
    let curleft = 0;
    let curtop = 0;
    let object = obj;
    if(obj.offsetParent) {
      do {
          curleft += object.offsetLeft;
          curtop += object.offsetTop;
      } while (object = object.offsetParent);
      return [curleft, curtop];
    }
  }
};



// WEBPACK FOOTER //
// ./modules/mixins/has_slider_events.js